export default "__VITE_ASSET__kbE$H0fU__"